import { IComponent } from '@app/interfaces/component';
import { Template } from '@app/utils/template';
import { ISubject, Subject, IObservable } from '@app/utils/observable';

export class NumberCardComponent implements IComponent {
    private nameElement: HTMLElement | null = null;
    private numberElement: HTMLElement | null = null;
    public element: HTMLElement | null = null;
	private onclicksubject: ISubject<NumberCardComponent, any>;

    private number: number | null = 0;

	public get onclick$(): IObservable<NumberCardComponent, any> {
		return this.onclicksubject;
	};

	constructor(public id: number, private name: string) {
		this.onclicksubject = new Subject();
	}

    render(): HTMLElement[] {
        if (this.element !== null) {
            return [this.element];
        }

        const root = Template.getById("number-card");

		root.addEventListener("click", () => {
			this.onclicksubject.emit(this, null);
		});

        this.nameElement = root.querySelector(".number-card__name") as HTMLElement;
        this.numberElement = root.querySelector(".number-card__number") as HTMLElement;

        this.element = root;

        this.updateNameElement();
        this.updateNumberElement();

        return [root];
    }

    setNumber(value: number) {
        this.number = value;
        this.updateNumberElement();
    }

    setAll() {
        this.number = null;
        this.updateNumberElement();
    }

    updateNameElement() {
        if (this.nameElement !== null) {
            this.nameElement.textContent = this.name;
        }
    }

    updateNumberElement() {
        if (this.numberElement !== null) {
            this.numberElement.textContent = this.number ? "" + this.number : $(this.numberElement).data("selectedAll");
        }
	}


}